<template>
  <div>
    <div class="vip">
      <div class="flex-js-ac">
        <p class="color-2 f16 flex-ac">50VIP会员权益</p>
        <van-button
          color="#FC0324"
          plain
          round
          type="primary"
          size="mini"
          @click="
            () => {
              if (Object.keys(kefuinfo).length > 0) {
                kefushow = true
              }
            }
          "
        >
          专属顾问
        </van-button>
      </div>
      <div class="ml12 mt12">
        <img class="vip50" src="/static/images/VIP/50@2x.png" alt="" />
      </div>
      <div class="flex-js-ac mt15">
        <p class="color-2 f16 flex-ac">升级途径</p>
      </div>
      <div v-if="info.totalmoney > info.money && info.totalmoney > info.paymoney">
        <span
          class="f12 ml12 color-2 content"
          v-if="info.totalmoney > info.money && info.totalmoney > info.paymoney"
        >
          自然年内累计消费{{ info.totalmoney }}元即可申请成为50VIP，您当前已消费{{
            info.paymoney
          }}元，其中{{ info.paymoney - info.money }}元的订单还在等待系统确认完结。
        </span>
        <span
          class="f12 ml12 color-2 content msg success"
          v-if="info.totalmoney > info.money && info.totalmoney > info.paymoney"
        >
          距离目标还差￥{{ info.totalmoney - info.paymoney }}，加油哦！
        </span>
      </div>
      <div v-if="info.totalmoney <= info.paymoney">
        <span class="f12 ml12 color-2 content success">恭喜您满足升级条件!</span>
        <span class="f12 ml12 color-2 content msg" v-if="info.totalmoney > info.money">
          等待待完结订单确认就可以申请成为VIP了。
        </span>
      </div>
      <div class="line_box money_box">
        <span
          class="money"
          :style="red_scale <= 14 ? { left: `0%` } : { right: `${100 - red_scale}%` }"
        >
          ¥{{ paymoney ? parseFloat(paymoney).toFixed(2) : '0.00' }}
        </span>
      </div>
      <div class="line_box">
        <div class="line yellow_line" :style="{ width: `${yellow_scale}%` }"></div>
        <div class="line red_line" :style="{ width: `${red_scale}%` }"></div>
        <div class="line black_line" :style="{ width: '100%' }"></div>
      </div>
      <div class="flex flex-w" style="margin-left: 0.08rem">
        <div class="yellow explain flex-ac flex-s" v-if="info.money && parseFloat(info.money) > 0">
          <span class="f10">已完成：¥{{ parseFloat(info.money).toFixed(2) }}</span>
        </div>
        <div class="red explain flex-ac flex-s" v-if="parseFloat(info.paymoney - info.money) > 0">
          <span class="f10">待完结：¥{{ parseFloat(info.paymoney - info.money).toFixed(2) }}</span>
        </div>
        <div
          class="black explain flex-ac flex-s"
          v-if="info.totalmoney > info.paymoney && parseFloat(info.totalmoney - info.paymoney) > 0"
        >
          <span class="f10">
            未完成：¥{{ parseFloat(info.totalmoney - info.paymoney).toFixed(2) }}
          </span>
        </div>
      </div>
    </div>
    <div class="h"></div>
    <footer class="footerIOS">
      <div
        class="agreement_box"
        v-if="
          (info.agreement && info.agreement.length && info.totalmoney <= info.money) ||
          info.isCanUpgrade == 1
        "
      >
        <div
          class="agreement_title color-FC0324 f12 mb10"
          v-if="
            !(info.agreement && info.agreement.length && info.totalmoney <= info.money) &&
            info.isCanUpgrade == 1
          "
        >
          说明：上年度已满足消费升级资格，可申请成为50VIP
        </div>
        <van-checkbox v-model="checked">
          <div class="agreement">
            勾选表示已阅读并同意
            <span v-for="(item, index) of info.agreement" @click="agreement(item)">
              《{{ item.name }}》
              <i v-if="index < info.agreement.length - 1">和</i>
            </span>
          </div>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
          </template>
        </van-checkbox>
      </div>
      <button class="btn" @click="submit">
        {{
          (info.totalmoney <= info.money && !isgohome) || info.isCanUpgrade == 1
            ? '我要申请'
            : '返回商城'
        }}
      </button>
    </footer>

    <!-- 2024-05-31 专属顾问弹窗 -->
    <van-overlay :show="kefushow" z-index="99999">
      <div class="wrapper">
        <div class="block" style="width: 75%" @click.stop>
          <div class="kefu">
            <img class="" :src="kefuinfo.head" alt="" />
            <p>
              {{ kefuinfo.nickname }}
              <span>（专属顾问）</span>
            </p>
            <span>{{ kefuinfo.mobile }}</span>
          </div>
          <van-icon name="close" @click="kefushow = false" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// import Vue from 'vue';
import { isWeixin, fenxiang } from '../../assets/common/js/config'

export default {
  name: 'vipupDetail',
  data() {
    return {
      info: {
        totalmoney: 0,
        paymoney: 0,
        money: 0
      },
      paymoney: 0,
      yellow_scale: 0,
      red_scale: 0,
      kefushow: false,
      kefuinfo: {},
      checked: false,
      isgohome: false,
      activeIcon: '/static/images/VIP/selected.png',
      inactiveIcon: '/static/images/VIP/default.png'
    }
  },
  mounted() {
    if (isWeixin()) {
      fenxiang({ path: 'vipupDetail' })
    }
    this.getData()
  },
  methods: {
    getData() {
      this.$customRequestAjax(this.$ajax.getMoney_URL).then((res) => {
        if (res.data.code == 200) {
          this.isgohome = false
          this.info = res.data
          this.kefuinfo = res.data.kefuinfo || {}
          this.info.totalmoney = parseFloat(this.info.totalmoney)
          this.info.paymoney = parseFloat(this.info.paymoney)
          this.info.money = parseFloat(this.info.money)
          let yellow_s, red_s
          yellow_s = (this.info.money / this.info.paymoney) * 90
          yellow_s = !isNaN(yellow_s) ? (yellow_s > 90 ? 90 : yellow_s) : 0
          red_s = (this.info.paymoney / this.info.totalmoney) * 90
          red_s = !isNaN(red_s) ? (red_s > 90 ? 90 : red_s) : 0
          this.yellow_scale = yellow_s < 2 && yellow_s > 0 ? 2 : yellow_s
          this.red_scale = red_s < 2 && red_s > 0 ? (yellow_s == red_s ? 2 : 2.5) : red_s
          let timetemp = 1000,
            step = this.info.paymoney / 100
          let timer = setInterval(() => {
            if (this.info.paymoney < this.paymoney + step) {
              this.paymoney = this.info.paymoney
              clearInterval(timer)
            } else {
              this.paymoney += step
            }
          }, timetemp / 100)
        } else {
          this.isgohome = true
          this.$toast(res.data.msg)
        }
      })
    },
    submit() {
      if (
        (this.info.totalmoney <= this.info.money && !this.isgohome) ||
        this.info.isCanUpgrade == 1
      ) {
        if (!this.checked) {
          this.$toast('申请前，必须勾选同意相关协议政策')
          return
        }
        this.$app.argLink({ path: '/vipapply' })
      } else {
        this.$app.goIndex()
      }
    },
    agreement(item) {
      this.$app.argStaticLink(item.link)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/common/css/footerSubmit';
.h {
  height: 0.93rem;
}
.agreement_box {
  position: absolute;
  bottom: 115%;
  left: 10%;
  right: 10%;
  .img-icon {
    width: 0.15rem;
    height: 0.15rem;
  }
}
.agreement {
  font-size: 0.15rem;
  color: #222222;
  span {
    color: #3894fb;
    i {
      color: #222222;
      font-style: normal;
    }
  }
}
.kefu {
  background: #ffffff;
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    margin: 0 auto 0.2rem;
    object-fit: cover;
  }
  p {
    font-size: 0.14rem;
    color: #222222;
    font-weight: bold;
    margin-bottom: 0.05rem;
  }
  span {
    font-size: 0.13rem;
    color: #6d6d6d;
  }
}
.line_box.money_box {
  position: relative;
  overflow: initial;
  margin-top: 0.1rem;
  margin-bottom: 0.06rem;
  span {
    position: absolute;
    color: #222222;
    font-size: 0.12rem;
    font-weight: 500;
  }
  .money {
    right: 86%;
    transition: all 1s;
    // left: 10%;
  }
}
.line_box {
  height: 0.19rem;
}
.line_box {
  margin-left: 0.08rem;
  border-radius: 1rem;
  overflow: hidden;
  position: relative;
  .line {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transition: all 1s;
  }
  .black_line {
    background: linear-gradient(270deg, #47464c 0%, #474449 100%);
  }
  .yellow_line {
    background: linear-gradient(270deg, #d2ba7c 0%, #f1e1b5 100%);
    z-index: 2;
  }
  .red_line {
    background: #fc0324;
    z-index: 1;
  }
}
.explain {
  margin-top: 0.1rem;
  &:nth-of-type(2) {
    margin-left: 0.4rem;
  }
  &.yellow::before {
    background: linear-gradient(270deg, #d2ba7c 0%, #f1e1b5 100%);
  }
  &.black::before {
    background: linear-gradient(270deg, #47464c 0%, #474449 100%);
  }
  &.red::before {
    background: #fc0324;
  }
  &::before {
    content: '';
    display: block;
    width: 0.2rem;
    height: 0.1rem;
    border-radius: 0.07rem;
  }
  span {
    color: #222222;
    margin-left: 0.1rem;
  }
}
.vip {
  margin: 0.1rem 0;
  padding: 0.15rem 0.11rem;
  padding-right: 0.23rem;
  border-radius: 0.1rem;
  background: #ffffff;
  p {
    font-weight: bold;
    &::before {
      content: '';
      display: inline-block;
      width: 0.04rem;
      height: 0.14rem;
      background: #222222;
      border-radius: 0.02rem;
      margin-right: 0.08rem;
    }
  }
  .van-button {
    height: 0.26rem;
    width: 0.64rem;
    .van-button__content {
      font-size: 0.11rem;
    }
  }
  .vip50 {
    width: 100%;
  }
  .ml12 {
    margin-left: 0.12rem;
  }
  .mt12 {
    margin-top: 0.12rem;
  }
  .mt15 {
    margin-top: 0.15rem;
  }
  .color-2 {
    color: #222222;
  }
  .content {
    display: block;
    margin-top: 0.1rem;
  }
  .msg {
    margin-top: 0.06rem;
    color: #fc0324;
  }
  .success {
    color: #bb7a00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upgradeVIP/vipupDetail.vue